import GUI from 'lil-gui'

export const gui = new GUI()
export const debugObject = {
    reset: () => {},
    createSphere: () => {},
    createBox: () => {},
    createCylinder: () => {},
    wireframe: false,
    friction: 0.1,
    restitution: 0.7,
    sphereColor: '#B7BDF7',
    boxColor: '#FFF8DE',
    cylinderColor: '#FF7444'
}